import React, { useContext, useState, useEffect } from 'react';
import { Grid } from 'react-feather';
import { Link } from 'react-router-dom';
import { Image } from '../../AbstractElements';
import CubaIcon from '../../assets/images/logo/logo.png';
import CustomizerContext from '../../_helper/Customizer';

const SidebarLogo = () => {
  const { mixLayout, toggleSidebar, layout, layoutURL } = useContext(CustomizerContext);
  
  // Sidebar is closed by default
  const [toggle, setToggle] = useState(true); 

  // Ensure the toggle state is reflected on mount
  useEffect(() => {
    toggleSidebar(toggle); // Set sidebar to closed on initial load
  }, [toggle, toggleSidebar]);

  const openCloseSidebar = () => {
    setToggle(!toggle); // Toggle the sidebar state
    toggleSidebar(!toggle); // Call context function to update sidebar state
  };

  const layout1 = localStorage.getItem('sidebar_layout') || layout;

  return (
    <div className='logo-wrapper'>
      {layout1 !== 'compact-wrapper dark-sidebar' && layout1 !== 'compact-wrapper color-sidebar' && mixLayout ? (
        <Link to={`${process.env.PUBLIC_URL}/pages/sample-page/${layoutURL}`}>
          <Image attrImage={{ className: 'img-fluid d-inline', src: `${CubaIcon}`, alt: '' ,style: { width: '150px', height: '50px' },}} />
        </Link>
      ) : (
        <Link to={`${process.env.PUBLIC_URL}/pages/sample-page/${layoutURL}`}>
          <Image attrImage={{ className: 'img-fluid d-inline', src: `${require('../../assets/images/logo/logo_dark.png')}`, alt: '' }} />
        </Link>
      )}
      {/* Button to toggle sidebar */}
      <div className='back-btn' onClick={() => openCloseSidebar()}>
        <i className={`fa ${toggle ? 'fa-angle-left' : 'fa-angle-right'}`}></i>
      </div>
      <div className='toggle-sidebar' onClick={openCloseSidebar}>
        <Grid className='status_toggle middle sidebar-toggle' />
      </div>
    </div>
  );
};

export default SidebarLogo;
